const svg = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path opacity="0.9" d="M13.7639 9.75174C13.7639 9.75174 6.82389 9.75174 4.15387 9.75174C4.42108 7.33452 6.47041 5.45441 8.95887 5.45441C11.4473 5.45441 13.4967 7.33452 13.7639 9.75174Z" fill="white"/>
<path opacity="0.9" d="M9.00006 2.94756V1.5M17.2501 10.5001H0.75M14.3405 5.15965L15.1365 4.36366M3.65963 5.15965L2.86364 4.36366" stroke="white" strokeWidth="1.50001" strokeLinecap="round"/>
</g>
</svg>`;

export default svg;
